<template>
  <div>
    <div class="screen">
      <div class="screen-wrap" @click="$refs.starttime.showTimePopup = true">
        <div>选择时间{{ date }}</div>
        <span class="iconfont">&#xe607;</span>
      </div>
    </div>
    <div class="sign" v-if="dataList.length > 0">
      <div class="sign-list">
        <div
          class="sign-item"
          :class="item.class"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <!-- <div class="time-line"></div> -->
          <div class="circle">
            <van-icon name="fail" v-if="item.state == -1" />
            <van-icon name="success" v-if="item.state == 1" />
            <van-icon name="cross" v-if="item.state == 0 || !item.state" />
          </div>
          <div class="line"></div>
          <div class="sign-info">
            <div>{{ item.text }}</div>
            <div>{{ item.time }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <van-empty description="暂无数据" />
    </div>
    <selectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      @time="handleTimeStartConfirm"
      :minDate="minDate"
      :maxDate="new Date()"
      type="date"
      :currentDate="startMinTime"
    />
  </div>
</template>

<script>
import selectTime from '@/components/subScribePopup/selectTime'
import moment from 'moment'
import { compare, getDateYMD, timeFormart } from '@/utils'

export default {
  data() {
    return {
      startMinTime: new Date(moment().format('YYYY-MM-DD')),
      minDate: new Date(2020, 1, 1),
      date: moment().format('YYYY-MM-DD'),
      dataList: [],
    }
  },
  methods: {
    selectT() {
      this.$refs.de.showTimePopup = true
    },
  },
  mounted() {
    this.getCalendar()
  },
  methods: {
    getDateYMD,
    handleTimeStartConfirm(val) {
      this.date = val
      this.getCalendar()
      // this.getClassesAttendance(true)
    },
    async getCalendar() {
      const { data, code } = await this.$https.getCalendar({
        userId: this.$store.state.userId,
        date: this.date,
      })
      if (code !== 200) {
        return false
      }
      const map = {
        '-1': ['迟到', 'sign-fail', '早退'],
        '0': ['未签到', 'sign-cross', '未签到'],
        '1': ['已签到', 'sign-suc', '已签到'],
        '-2': ['早退', 'sign-fail', '早退'],
      }
      let res = []
      data.forEach((item) => {
        res.push({
          state: item.amFirstClockState,
          time: item.amFirstClockTime ? getDateYMD(item.amFirstClockTime) : '',
          text: item.amFirstClockState
            ? '上午上班' + map[item.amFirstClockState][0]
            : '未打卡',
          class: item.amFirstClockState ? map[item.amFirstClockState][1] : '',
        })
        res.push({
          state: item.amLastClockState,
          text: item.amLastClockState
            ? '上午下班' + map[item.amLastClockState][2]
            : '未打卡',
          time: item.amLastClockTime ? getDateYMD(item.amLastClockTime) : '',
          class: item.amLastClockState ? map[item.amLastClockState][1] : '',
        })
        res.push({
          state: item.pmFirstClockState,
          text: item.pmFirstClockState
            ? '下午上班' + map[item.pmFirstClockState][0]
            : '未打卡',
          time: item.pmFirstClockTime ? getDateYMD(item.pmFirstClockTime) : '',
          class: item.pmFirstClockState ? map[item.pmFirstClockState][1] : '',
        })
        res.push({
          state: item.pmLastClockState,
          text: item.pmLastClockState
            ? '下午下班' + map[item.pmLastClockState][0]
            : '未打卡',
          time: item.pmLastClockTime ? getDateYMD(item.pmLastClockTime) : '',
          class: item.pmLastClockState ? map[item.pmLastClockState][1] : '',
        })
      })
      this.dataList = res
    },
  },
  components: {
    selectTime,
  },
}
</script>

<style lang="scss" scoped>
::deep .van-icon {
  font-size: 0.5rem;
}
.screen {
  padding: 1rem 1rem 0;
  .screen-wrap {
    background: #fff;
    padding: 0.8rem 1rem;
    border-radius: 0.75rem;
    color: #999;
    font-size: 0.85rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 0.75rem;
    }
  }
}
.sign {
  padding: 1rem;
  .sign-list {
    border-radius: 0.75rem;
    /* overflow: hidden; */
    background: #fff;
    .sign-item {
      display: flex;
      position: relative;
      padding-left: 3rem;
      &:last-child {
        .line {
          width: 0;
        }
      }
      &.sign-suc {
        /* .line {
          background: rgb(63, 199, 63);
        } */
        .circle {
          background: rgb(63, 199, 63);
          color: #fff;
        }
      }
      &.sign-fail {
        /* .line {
          background: rgb(223, 174, 41);
        } */
        .circle {
          background: rgb(223, 174, 41);
          color: #fff;
        }
      }
      &.sign-cross {
        /* .line {
          background: rgb(223, 53, 41);
        } */
        .circle {
          background: rgb(223, 53, 41);
          color: #fff;
        }
      }
      .line {
        width: 1px;
        height: 100%;
        position: absolute;
        background: #f0f0f0;
        left: 1.45rem;
        top: 1rem;
      }
      .circle {
        position: absolute;
        left: 1rem;
        z-index: 1;
        background: #f0f0f0;
        border-radius: 50%;
        width: 1rem;
        height: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 1rem;
      }
      .sign-info {
        flex: 1;
        padding: 1rem 0;
        margin-right: 1rem;
        border-bottom: 1px solid #f4f4f6;
        font-size: 0.85rem;
      }
    }
  }
}
</style>
